var _circle, _g, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1873_2481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 37
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1285,
    cy: 18.5123,
    r: 18.3331,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.211943
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1873_2481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42534 32.2886C8.42534 26.3774 13.2173 21.5855 19.1284 21.5855C25.0396 21.5855 29.8316 26.3774 29.8316 32.2886V35.4677C29.8316 41.3789 25.0396 46.1709 19.1284 46.1709C13.2173 46.1709 8.42534 41.3789 8.42534 35.4677V32.2886Z",
    stroke: "#053772",
    strokeWidth: 0.635828
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1285,
    cy: 18.5123,
    r: 18.1211,
    stroke: "#053772",
    strokeWidth: 0.635828
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2328,
    cy: 14.8034,
    r: 6.35828,
    stroke: "#053772",
    strokeWidth: 0.635828
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.1202ed9c2704f4b54feaf629dc410a0e.svg";
export { ForwardRef as ReactComponent };